import { ResourceConfigModal } from '@/delivery-type-plugin/components/resourceConfig';

import { SharedMemoryBlock } from './SharedMemoryBlock';
import { SHARED_MEMORY_MODAL_CONFIG_FIELD, SHARED_MEMORY_RESOURCE_MODAL_TITLE } from './constants';
import { clampSharedMemoryConfigToMin, hasMeaningfulSharedMemoryConfig } from './sharedMemoryForm';
import type { SharedMemoryFormValues } from './types';

export interface SharedMemoryConfigModalProps {
  initialValues?: Record<string, unknown>;
  onOk: (values: Record<string, unknown>) => void;
  onCancel: () => void;
  min?: number;
}

/** 共享内存配置弹窗 */
export function SharedMemoryConfigModal({ initialValues, onOk, onCancel, min }: SharedMemoryConfigModalProps) {
  const clampedInitial = {
    ...(initialValues ?? {}),
    [SHARED_MEMORY_MODAL_CONFIG_FIELD]: clampSharedMemoryConfigToMin(
      (initialValues?.[SHARED_MEMORY_MODAL_CONFIG_FIELD] as SharedMemoryFormValues | undefined) ?? undefined,
      min,
    ),
  };
  return (
    <ResourceConfigModal
      visible
      title={SHARED_MEMORY_RESOURCE_MODAL_TITLE}
      resourceCode="SharedMemory"
      vendorDevicePrefix="_sharedMemoryPricing"
      vendorDeviceHidden
      initialValues={clampedInitial}
      validateFields={[`${SHARED_MEMORY_MODAL_CONFIG_FIELD}.sizeLimit`]}
      canSubmit={(values) => {
        const config = values[SHARED_MEMORY_MODAL_CONFIG_FIELD] as SharedMemoryFormValues | undefined;
        return hasMeaningfulSharedMemoryConfig(config);
      }}
      onOk={onOk}
      onCancel={onCancel}
    >
      {(modalForm) => (
        <SharedMemoryBlock form={modalForm} paths={{ config: SHARED_MEMORY_MODAL_CONFIG_FIELD }} blockMode="edit" min={min} />
      )}
    </ResourceConfigModal>
  );
}
